import {Section} from "../grouping/Section";
import {Button, Col, Form, FormControl, FormGroup, FormLabel, FormSelect} from "react-bootstrap";
import {SelectionList} from "../SelectionList";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {PARTNER_EMPTY, usePartnerMutations, usePartners} from "../../api/partnerapi";
import {useCallback, useState} from "react";
import {ListItemButton} from "../ListItemButton";
import {FILE_EMPTY, useFileMutations} from "../../api/fileapi";
import {useForm} from "../../utilities/formutilities";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {ButtonLoading} from "../ButtonLoading";
import {ConfirmToast} from "../ConfirmToast";

export function PartnerOption(props) {
    const {partners} = usePartners();
    const [open, setOpen] = useState(false);
    const [fileEditing, setFileEditing] = useState(undefined);
    const {title} = props;
    return <Section title={title}>
        <Col xs={12} className={"text-end"}>
            <Button onClick={() => setOpen(true)}>Nieuw</Button>
        </Col>
        <SelectionList>
            {partners ? partners.sort((p1, p2) => p1.position - p2.position).map(p => <ListItem key={p.id}
                                                                                                onOpenChanged={setOpen}
                                                                                                partner={p}
                                                                                                onFileEditingChanged={setFileEditing}></ListItem>) : ""}
        </SelectionList>
        <ModalPopUp open={open} onOpenChanged={setOpen} title={"Nieuw bestand link"}
                    modalContent={<FileOptionModalContent fileEditing={fileEditing} setFileEditing={setFileEditing}
                                                          onOpenChanged={setOpen}/>}/>
    </Section>
}


function ListItem(props) {
    const {partner, onOpenChanged, icon, onFileEditingChanged} = props;
    return <div className={"mt-1 border border-black rounded-2"}>
        <ListItemButton onClick={() => {
            onFileEditingChanged(partner);
            onOpenChanged(true);
        }}>
            <Col className={"text-start"}>
                {partner ? partner.title : "Geen Titel"}
            </Col>
            <Col xs={"auto"} className={"text-end"}>
                {icon}
            </Col>
        </ListItemButton>
    </div>
}

function FileOptionModalContent(props) {
    const [isLoading, setIsLoading] = useState(false);
    const {fileEditing, onOpenChanged, setFileEditing} = props;
    const {createPartner, editPartner, editAddNewFiles, deletePartner} = usePartnerMutations();
    const initialObjectInintializer = useCallback(() => fileEditing ? {...fileEditing} : {...PARTNER_EMPTY}, []);
    const initialFileObjectInitializer = useCallback(() => FILE_EMPTY, []);
    const {tempFileObject, onFileInputChange} = useForm(initialFileObjectInitializer);
    const {tempObject, onChange} = useForm(initialObjectInintializer);
    const {uploadFile} = useFileMutations();

    async function handleCreateSubmit(e) {
        e.preventDefault();

        const result = await createPartner(tempObject);
        if (result && tempFileObject.file !== "") {
            const objReturn = await uploadFile(tempFileObject);
            if (objReturn) {
                await editAddNewFiles({...result, fileId: objReturn.id})
            }
        }
        setIsLoading(false);
        onOpenChanged(false);


    }

    async function handleEditSubmit(e) {
        e.preventDefault();
        const result = await editPartner(tempObject);
        if (result) {
            if (tempFileObject.file !== "") {
                const objReturn = await uploadFile(tempFileObject);
                if (objReturn) {
                    await editAddNewFiles({...result, fileId: objReturn.id})
                }
            }
        }
        setIsLoading(false);
        setFileEditing(undefined);
        onOpenChanged(false);
    }

    return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={setFileEditing}>
        <Form onSubmit={(event) => {
            fileEditing ? handleEditSubmit(event) : handleCreateSubmit(event)
        }}>
            <Section title={fileEditing ? "Wijzig partner" : "Nieuwe partner"}>
                <FormGroup>
                    <FormLabel>Titel</FormLabel>
                    <FormControl value={tempObject ? tempObject.title : ""}
                                 onChange={event => onChange(event, "title")}/>
                </FormGroup>
                <FormGroup>
                    <FormLabel>url</FormLabel>
                    <FormControl value={tempObject ? tempObject.url : ""}
                                 onChange={event => onChange(event, "url")}/>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Positie in lijst</FormLabel>
                    <FormControl type={"number"} value={tempObject?.position ? tempObject.position : 1}
                                 onChange={event => onChange(event, "position")}/>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Logo</FormLabel>
                    <FormControl onChange={(e) => onFileInputChange(e, 'file')} type={"file"}/>
                </FormGroup>


                {fileEditing
                    ?
                    <Col xs={6}>
                        <ConfirmToast title={"Delete"} className={"btn-danger mt-3"}
                                      message={"Wil je deze partner verwijderen?"}
                                      executeFunction={async () => {
                            const message = await deletePartner(fileEditing);
                            if (message)
                                onOpenChanged(false);
                            setFileEditing(undefined);
                        }}/>

                    </Col>
                    :
                    ""
                }
                <Col xs={fileEditing ? 6 : 12} className={"text-end mt-3"}>
                    <ButtonLoading title={"Opslaan"} isLoading={isLoading} onClick={(e) => {
                        setIsLoading(true);
                        fileEditing ? handleEditSubmit(e) : handleCreateSubmit(e)
                    }}/> </Col>
            </Section>
        </Form>
    </ModalContentContainer>
}